var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SelectComponent',{attrs:{"items":"/api/resource/page?field.id=id&field.label=name&field.thumbnail=media.logo.url","search":"","label":_vm.$t('selectx', { x: _vm.$tc('page', 1).toLowerCase() })},model:{value:(_vm.publishRelation),callback:function ($$v) {_vm.publishRelation=$$v},expression:"publishRelation"}})
}
var staticRenderFns = []

export { render, staticRenderFns }